import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/mine",
				name: "mine",
				component: () => import("../views/todo/mine.vue"),
			},
			{
				path: "/share",
				name: "share",
				component: () => import("../views/todo/share.vue"),
			},
			{
				path: "/todo",
				name: "todo",
				component: () => import("../views/todo/todo.vue"),
			},
			{
				path: "/analyse",
				name: "analyse",
				component: () => import("../views/todo/analyse.vue"),
			},
			{
				path: "/history",
				name: "history",
				component: () => import("../views/todo/history.vue"),
			},
			{
				path: "/dict",
				name: "dict",
				component: () => import("../views/todo/dict.vue"),
			},
			{
				path: "/config",
				name: "config",
				component: () => import("../views/todo/config.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/todo/config_right.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
